//Constants
import { SET_LANGUAGE } from "REDUX/constants";

const initialState = {
  selectedLanguage: navigator.languages[0],
};
export default function languageReducer(state = initialState, action) {
  if (action.type === SET_LANGUAGE) {
    let language;
    switch (action.data.language) {
      case "ar":
        language = action.data.language;
        break;
      default:
        language = "en";
    }
    return { ...state, selectedLanguage: language };
  } else return state;
}



// WEBPACK FOOTER //
// ./src/modules/App/reducers/Language.js